import { Button, Feed, Header, Icon, Item, Segment } from "semantic-ui-react";
import { Notification } from "../models/Notification";
import moment from "moment";
import { MouseEvent } from "react";
import Background from "esri/webscene/background/Background";

type Props = {
  notifications?: Notification[];
  onDismissNotifications: (ids: string[]) => void;
};

function NotificationsList({ notifications, onDismissNotifications }: Props) {
  const notSeenCount = notifications?.filter((n) => !n.seen).length ?? 0;

  const handleDismissNotifications = (e: MouseEvent, ids: string[]) => {
    e.stopPropagation();
    onDismissNotifications(ids);
  };

  return (
    <Segment basic style={{ marginTop: "5em" }}>
      <Header dividing>Notifications</Header>

      {(!notifications || notifications.length === 0) && <Header as="h4">You don't have any notifications</Header>}
      <Segment basic style={{ maxHeight: "500px", overflowY: "auto", backgroundColor: "#f9f9f9" }}>
        <Feed size="small">
          {notifications &&
            notifications.map((notification) => (
              <Feed.Event key={notification.id}>
                <Feed.Content>
                  <Feed.Date>
                    {notification.organizationName} / {notification.projectName}
                    <div style={{ float: "right" }}>{moment(notification.dateCreatedUtc).local().fromNow()}</div>
                  </Feed.Date>

                  {!notification.seen && <Feed.Summary>{notification.text}</Feed.Summary>}
                  {notification.seen && <Feed.Extra text>{notification.text}</Feed.Extra>}

                  <Feed.Meta>
                    <Feed.Like
                      style={{ border: "0px", cursor: "pointer" }}
                      as="Button"
                      onClick={(e: MouseEvent) => {
                        handleDismissNotifications(e, [String(notification.id)]);
                      }}
                    >
                      <Icon name="delete" /> Dismiss
                    </Feed.Like>
                  </Feed.Meta>
                </Feed.Content>
              </Feed.Event>
            ))}
        </Feed>
      </Segment>
      {notifications && notifications.length > 0 && (
        <Button
          floated="right"
          basic
          compact
          onClick={(e) => {
            handleDismissNotifications(
              e,
              notifications.map((n) => String(n.id)),
            );
          }}
        >
          Dismiss all <Icon name="delete" />
        </Button>
      )}
    </Segment>
  );
}

export default NotificationsList;
